import React, { useEffect, useRef, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { nav, site } from '../data/site';
import lockupDark from '../../images/lockup-dark.svg';

export default function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const firstRender = useRef(true);

  // Close the mobile menu whenever the route changes.
  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    setOpen(false);
  }, [location.pathname]);

  // Escape closes the menu, as a disclosure is expected to.
  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (event) => {
      if (event.key === 'Escape') setOpen(false);
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [open]);

  return (
    <header className={`vm-header${open ? ' vm-header--open' : ''}`}>
      <div className="vm-header__inner">
        {/* `exact`, or the brand link is "active" — and so carries
            aria-current="page" — on every page of the site. */}
        <NavLink to="/" exact className="vm-brand">
          <img
            src={lockupDark}
            alt={`${site.name} — home`}
            className="vm-brand__logo"
          />
        </NavLink>

        <button
          type="button"
          className="vm-nav-toggle"
          aria-expanded={open}
          aria-controls="vm-main-nav"
          onClick={() => setOpen((value) => !value)}
        >
          {open ? 'Close' : 'Menu'}
        </button>

        <nav id="vm-main-nav" className="vm-nav" aria-label="Main">
          {nav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              exact={item.to === '/'}
              className="vm-nav__link"
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <NavLink to="/contact" className="vm-btn vm-btn--header vm-header__cta">
          Get in touch
        </NavLink>
      </div>
    </header>
  );
}
